/**
 * Subscription product template: real cart/add form + Ajax so Recharge can use
 * input[name="selling_plan"] and standard product form hooks.
 */
(function () {
  function normalizeSellingPlanId(raw) {
    if (raw == null || raw === '') return null;
    var s = String(raw).trim();
    if (!s) return null;
    var m = s.match(/SellingPlan\/(\d+)/);
    if (m) return m[1];
    if (/^\d+$/.test(s)) return s;
    return null;
  }

  function collectSellingPlanFromRoot(root) {
    if (!root || !root.querySelectorAll) return null;
    var fields = root.querySelectorAll(
      'input[name="selling_plan"], select[name="selling_plan"], input[name="selling_plan_id"], select[name="selling_plan_id"], input[name="selling_plan_allocation"]'
    );
    for (var i = 0; i < fields.length; i++) {
      var v = normalizeSellingPlanId(fields[i].value);
      if (v) return v;
    }
    var radios = root.querySelectorAll('input[type="radio"][name*="selling"]:checked, input[type="radio"][name*="purchase"]:checked');
    for (var j = 0; j < radios.length; j++) {
      v = normalizeSellingPlanId(radios[j].value);
      if (v) return v;
    }
    return null;
  }

  function deepScanSellingPlan(root, out) {
    if (!root || !root.querySelectorAll || out.v) return;
    var fp = collectSellingPlanFromRoot(root);
    if (fp) {
      out.v = fp;
      return;
    }
    var all = root.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      if (out.v) return;
      if (all[i].shadowRoot) deepScanSellingPlan(all[i].shadowRoot, out);
    }
  }

  function findSellingPlanId(section, form) {
    var planInput = form.querySelector('input[name="selling_plan"], select[name="selling_plan"]');
    if (planInput) {
      var fromForm = normalizeSellingPlanId(planInput.value);
      if (fromForm) return fromForm;
    }
    var out = { v: null };
    deepScanSellingPlan(form, out);
    if (out.v) return out.v;
    var widgetRoot = form.querySelector('[data-subscription-widgets]');
    if (widgetRoot) deepScanSellingPlan(widgetRoot, out);
    if (out.v) return out.v;
    deepScanSellingPlan(section, out);
    if (out.v) return out.v;
    var withData = section.querySelector('[data-selling-plan-id]');
    if (withData) {
      var id = normalizeSellingPlanId(withData.getAttribute('data-selling-plan-id'));
      if (id) return id;
    }
    return null;
  }

  function buildBiltongProperties(packEl) {
    var properties = {};
    var productTitle = packEl.getAttribute('data-product-title');
    var checked = packEl.querySelector('input[name="pack_size"]:checked');
    if (!checked || !productTitle) return properties;

    var li = checked.closest('[data-variant-id]');
    if (!li) return properties;

    var biltong_size = checked.getAttribute('data-size');
    var flavour_position = checked.getAttribute('data-flavour-id-position');
    var variantTitle = li.getAttribute('data-variant-title') || '';
    var weight = variantTitle.split(' (')[0];
    var trueId;
    var el;

    if (flavour_position === '1' || flavour_position === '4') {
      el = document.querySelector("[data-flavour-id-position='1']");
      trueId = el && el.getAttribute('data-flavour-true-id');
    } else if (flavour_position === '2' || flavour_position === '5') {
      el = document.querySelector("[data-flavour-id-position='2']");
      trueId = el && el.getAttribute('data-flavour-true-id');
    } else if (flavour_position === '3' || flavour_position === '6') {
      el = document.querySelector("[data-flavour-id-position='3']");
      trueId = el && el.getAttribute('data-flavour-true-id');
    }

    if (!biltong_size || !trueId) return properties;

    properties.Flavour = productTitle;
    var product_key = productTitle.replace(/ Biltong/g, '');
    product_key = product_key.replace('GO M-EAT!', 'GO m-eat!');
    properties[product_key + ' ' + weight] = biltong_size;

    var n = parseInt(biltong_size, 10);
    if (isNaN(n) || n < 1) return properties;
    var biltongIndex = 1;
    for (var i = 0; i < n; i++) {
      properties['flavour_' + biltongIndex + '_variant_id'] = trueId;
      biltongIndex += 1;
    }
    return properties;
  }

  function syncPackUi(form) {
    var packEl = form.closest('.pack');
    if (!packEl) return;
    var checked = form.querySelector('input[name="pack_size"]:checked');
    var idInput = form.querySelector('input[name="id"]');
    var qtyEl = form.querySelector('select[name="quantity"]');
    var quantity = qtyEl ? qtyEl.value : '1';
    var info = form.querySelector('.info');
    var submitBtn = form.querySelector('button[type="submit"].add');

    if (checked) {
      var li = checked.closest('[data-variant-id]');
      if (!li) return;
      var variantId = li.getAttribute('data-variant-id');
      var variantTitle = li.getAttribute('data-variant-title');
      var variantPrice = li.getAttribute('data-variant-price');
      if (idInput) idInput.value = variantId || checked.value || checked.id;
      if (info) {
        var sv = info.querySelector('.selected-variant');
        var sq = info.querySelector('.selected-quantity');
        if (sv) sv.innerHTML = ' - ' + variantTitle + ' - ' + variantPrice;
        if (sq) sq.innerHTML = 'x' + quantity;
      }
      if (submitBtn) {
        submitBtn.setAttribute('data-variant-id', variantId || '');
        submitBtn.setAttribute('data-quantity', quantity);
      }
    } else {
      if (info) {
        var sqOnly = info.querySelector('.selected-quantity');
        if (sqOnly) sqOnly.innerHTML = 'x' + quantity;
      }
      if (submitBtn) {
        submitBtn.setAttribute('data-variant-id', idInput ? idInput.value : '');
        submitBtn.setAttribute('data-quantity', quantity);
      }
    }
  }

  function onFormSubmit(e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-product-subscription-ajax]')) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var section = form.closest('.product-template--subscription');
    var packEl = form.closest('.pack');
    if (!section || !packEl) return;

    syncPackUi(form);

    var idInput = form.querySelector('input[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    var variantId = idInput && idInput.value;
    var quantity = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
    if (!variantId) return;

    var sellingPlanId = findSellingPlanId(section, form);
    var planField = form.querySelector('input[name="selling_plan"]');
    if (planField && sellingPlanId) planField.value = sellingPlanId;

    var properties = buildBiltongProperties(packEl);
    var item = {
      id: Number(variantId),
      quantity: quantity
    };
    if (Object.keys(properties).length) item.properties = properties;
    if (sellingPlanId) item.selling_plan = Number(sellingPlanId);

    var submitBtn = form.querySelector('button[type="submit"]');
    var prevText = submitBtn ? submitBtn.textContent : '';
    if (submitBtn) {
      submitBtn.classList.add('disabled', 'loader');
      submitBtn.textContent = '';
      submitBtn.disabled = true;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items: [item] }),
      credentials: 'same-origin'
    })
      .then(function (res) {
        return res.json().then(function (body) {
          if (!res.ok) throw new Error((body && body.description) || body.message || res.statusText);
          return body;
        });
      })
      .then(function () {
        if (typeof window.CartJS !== 'undefined' && typeof window.CartJS.getCart === 'function') {
          window.CartJS.getCart();
        }
        var imageSrc = packEl.getAttribute('data-featured-image');
        var productTitle = packEl.getAttribute('data-product-title');
        var checked = form.querySelector('input[name="pack_size"]:checked');
        var li = checked && checked.closest('[data-variant-id]');
        var vTitle = li ? li.getAttribute('data-variant-title') : '';
        if (!vTitle && productTitle) vTitle = productTitle;
        if (typeof window.addToCartSlide === 'function') {
          setTimeout(function () {
            window.addToCartSlide(imageSrc, productTitle, vTitle, String(quantity));
          }, 350);
        }
      })
      .catch(function (err) {
        console.error('Subscription add to cart:', err);
      })
      .finally(function () {
        setTimeout(function () {
          if (submitBtn) {
            submitBtn.textContent = prevText || 'Add';
            submitBtn.classList.remove('disabled', 'loader');
            submitBtn.disabled = false;
          }
        }, 1000);
      });
  }

  function bindForm(form) {
    var submitBtn = form.querySelector('button.add');
    if (submitBtn) {
      submitBtn.addEventListener('click', function (ev) {
        ev.stopPropagation();
      });
    }
    form.addEventListener('submit', onFormSubmit, true);
    form.addEventListener('change', function (ev) {
      if (ev.target.matches('input[name="pack_size"], select[name="quantity"]')) {
        syncPackUi(form);
      }
    });
    form.addEventListener('click', function (ev) {
      if (ev.target.closest('label[for]') || ev.target.closest('.pack-size')) {
        setTimeout(function () {
          syncPackUi(form);
        }, 0);
      }
    });
    syncPackUi(form);
  }

  window.addEventListener('load', function () {
    if (!document.querySelector('.product-template--subscription')) return;
    document.querySelectorAll('form[data-product-subscription-ajax]').forEach(bindForm);
  });
})();
